import React, { Fragment, useEffect, useState } from "react"
import { Menu, Transition } from "@headlessui/react"
import { ChevronDown16, Location16 } from "@carbon/icons-react"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import { useTranslation } from "react-i18next"

const websitesMapping = require("../../../config/websites")
const websites = websitesMapping["websitesMapping"]

const MetaNav = () => {
  const [currentWebsite, setCurrentWebsite] = useState(null)
  const [otherWebsites, setOtherWebsites] = useState(null)

  const { t } = useTranslation()

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentWebsite(
        websites.find(
          (w) => w.url.split("/")[1] === window.location.pathname.split("/")[1]
        ) || null
      )
      setOtherWebsites(websites)
    }
  }, [])

  const dealerSearch = () => {
    if (currentWebsite) {
      switch (currentWebsite.url) {
        case "/de": {
          return process.env.GATSBY_DEALER_SEARCH_PAGE_PATH_DE
        }
        case "/en": {
          return process.env.GATSBY_DEALER_SEARCH_PAGE_PATH_EN
        }
        case "/fr": {
          return process.env.GATSBY_DEALER_SEARCH_PAGE_PATH_FR
        }
        case "/dk": {
          return process.env.GATSBY_DEALER_SEARCH_PAGE_PATH_DK
        }
        case "/es": {
          return process.env.GATSBY_DEALER_SEARCH_PAGE_PATH_ES
        }
        default: {
          return process.env.GATSBY_DEALER_SEARCH_PAGE_PATH_DE
        }
      }
    }
  }

  return (
    <div className="hidden w-full text-white bg-ruko-gray md:block">
      <div className="flex flex-row mx-auto max-w-screen-xl">
        {currentWebsite !== null && (
          <Menu as="div" className="relative">
            {({ open }) => (
              <>
                <Menu.Button
                  className={`btn hover:text-white ${open ? "text-white" : ""}`}
                >
                  {currentWebsite && currentWebsite.title.split(" – ")[0]}
                  <ChevronDown16
                    className={`inline-block ml-2 -mt-0.5 align-middle transition-transform duration-300 transform ${
                      open ? "rotate-180" : ""
                    }`}
                  />
                </Menu.Button>
                <Transition
                  as={Fragment}
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-50 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-50 opacity-0"
                >
                  <Menu.Items
                    as="ul"
                    className="absolute left-0 right-auto z-50 min-w-full px-4 overflow-y-auto origin-top-left shadow-lg bg-ruko-gray top-full whitespace-nowrap"
                  >
                    {otherWebsites?.length > 0 &&
                      otherWebsites.map((w) => (
                        <Menu.Item as="li" key={w.url}>
                          <Link
                            className={`block relative px-0 border-t btn hover:text-white border-gray-400${
                              w.url === currentWebsite.url
                                ? " text-primary"
                                : ""
                            }`}
                            link={w.url}
                            isCrossWebsiteLink={true}
                          >
                            {w.title}
                          </Link>
                        </Menu.Item>
                      ))}
                  </Menu.Items>
                </Transition>
              </>
            )}
          </Menu>
        )}
        <div className="inline-block ml-auto">
          {/* <Link className="text-gray-200 btn hover:text-white" link="/">
            Merkzettel
            <Favorite16 className="inline-block ml-2 -mt-0.5 align-middle" />
          </Link>
          <span className="inline-block w-px h-12 align-bottom">
            <span className="inline-block w-px h-6 my-3 bg-gray-600"></span>
          </span>
          <Link className="text-gray-200 btn hover:text-white" link="/">
            Artikelvergleich
            <Renew16 className="inline-block ml-2 -mt-0.5 align-middle" />
          </Link>
          <span className="inline-block w-px h-12 align-bottom">
            <span className="inline-block w-px h-6 my-3 bg-gray-600"></span>
          </span> */}
          <Link
            link={dealerSearch()}
            className="text-white btn hover:text-primary"
          >
            {t("generic.meta_nav.dealer_search")}
            <Location16 className="inline-block ml-2 -mt-0.5 align-middle" />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default MetaNav
